<template>
<div class="reveal bibreveal" id="linksPopup" data-reveal>
  <div class="centerContent">
      <p class="carouselTitle horario">{{ $t("UMA_LANG_SASUMA_HOME_FOOTER_LIGACOES") }}</p>
      <span class="curso_linha3 azul_site_background"></span>
  </div>
  <div class="row">
    <div class="small-12 medium-12 large-12 columns linkscontent">
      <a :href="link.link" v-for="link in links">
        <i class="fa fa-caret-right" aria-hidden="true"></i>
        {{ link.titulo }}
      </a>  
    </div>
  </div>
  <button class="close-button horario" data-close aria-label="Close modal" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
</template>

<script>
import axios from '@/axios';
import { i18n } from '@/main.js';
import { ref, onMounted, nextTick } from 'vue';

export default {
  setup () {

    const links = ref([]);

    const lang = i18n.global.locale;

    axios.get(`/links?owner=${import.meta.env.VITE_APP_OWNER}&idioma=${lang}`)
      .then(response => {
        links.value = response.data.data;
      }).
      catch(error => {
        console.log(error);
      })
    
    onMounted(() => {
      nextTick(() => {
        const accord = $(".bibreveal");
        $(accord).foundation();
      })
    })

    return {
      links
    }
  }
}
</script>

<style lang="scss" scoped>
#linksPopup {
  width: 30%;
  max-width: 30%;
  top:109px !important;
}

.reveal-overlay{
  z-index: 999999999;
}

.reveal.bibreveal{
  width: 100%;
  max-width: 100%;
  padding: 50px;
}

.reveal.bibreveal .carouselTitle{
  padding-top: 0;
}

.reveal.bibreveal .curso_linha3{
  margin-bottom: 40px;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.carouselTitle {
  font-family: 'Montserrat Bold';
  font-size: 30px;
  margin-top: 0px;
  color: #333333;
  display: inline-block;
  margin-bottom: 5px;
  padding-top: 85px;
}

.horario_text {
  font-family: "Montserrat";
  padding-top: 10px;
  margin-bottom: 20px;
}

.linkscontent a{
  display: flex;
  flex: 1;
  margin-bottom: 20px;
  font-family: "Montserrat";
  color: #494d52;
}
.linkscontent a:hover{
  color: #1468a0;
}
.linkscontent a i {
  color: #6eb7ec;
  margin-right: 7px;
  display: flex;
  align-self: center;
  font-size: 20px;
}
</style>